import { IframeHTMLAttributes } from "react";

interface IFrameProps extends IframeHTMLAttributes<HTMLIFrameElement> {}

export const IFrame = (props: Readonly<IFrameProps>) => {
  return <iframe id="my-frame" {...props} title={props.title} />;
};
